/**
 * Shared look for the picker's fields. Inline styles on the dashboards tokens,
 * because the dashboards button reset outranks single utility classes; the
 * picker must sit inside `.nb-dashboards` for the tokens to resolve.
 */
import type { CSSProperties } from 'react';

export const fieldLabelStyle: CSSProperties = {
  fontSize: 10,
  fontWeight: 800,
  letterSpacing: '.06em',
  textTransform: 'uppercase',
  color: 'var(--nb-subtle)',
};

/** A 38px input-like box: green when active, orange when wrong. */
export function fieldBoxStyle(active: boolean, invalid: boolean): CSSProperties {
  const border = invalid ? 'var(--nb-warn)' : active ? 'var(--nb-primary)' : 'var(--nb-border)';
  return {
    height: 38,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '0 11px',
    borderRadius: 8,
    border: `1px solid ${border}`,
    boxShadow: active ? '0 0 0 3px var(--nb-primary-soft)' : 'none',
    background: 'var(--nb-bg)',
    color: 'var(--nb-ink)',
    fontSize: 13.5,
    fontWeight: 600,
    minWidth: 0,
  };
}

export const bareInputStyle: CSSProperties = {
  flex: 1,
  minWidth: 0,
  border: 0,
  outline: 'none',
  background: 'transparent',
  fontSize: 13.5,
  fontWeight: 600,
  fontVariantNumeric: 'tabular-nums',
  color: 'var(--nb-ink)',
};
